module.exports = {
  name: 'show2',
  settings: {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    mobileFirst: true,
    swipeToSlide: true,
    responsive: [
      { breakpoint: 'sm',
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  },
}
